import createContextData from '../createContextData';

const reducer = (state, action) => {
    switch (action.type) {
        case 'SET_PAGE':
            return action.payload;
        default:
            return state
    }
}

const setPage = dispatch => {
    return (limit) => {
        dispatch({ type: 'SET_PAGE', payload: limit })
    }
}

export const { Context, Provider } = createContextData(
    reducer,
    { setPage },
    1
)